import * as React from 'react'
import type { RouteObject } from 'react-router'

const TopUp = React.lazy(() => import('../views/TopUp/TopUp'))
const MasterPass3D = React.lazy(
    () => import('../views/MasterPass3D/MasterPass3D'),
)
const Payment3D = React.lazy(() => import('../views/GoldFramer/Payment3D'))
const CashRespond = React.lazy(() => import('../views/CashRespond/CashRespond'))
const TopUpInstruction = React.lazy(
    () => import('../views/TopUpInstruction/TopUpInstruction'),
)

export const DepositRouter: RouteObject[] = [
    {
        path: '/topup',
        element: <TopUp />,
    },
    {
        path: '/topup-instruction',
        element: <TopUpInstruction />,
    },
    {
        path: '/masterpass-3d',
        element: <MasterPass3D />,
    },
    {
        path: '/payment-3d',
        element: <Payment3D />,
    },
    {
        path: '/cash-respond',
        element: <CashRespond />,
    },
]
